export default "__VITE_ASSET__DSHQe1ji__"